import { X } from "lucide-react";
import StripeEmbeddedCheckout from "@/v2/components/checkout/StripeEmbeddedCheckout";

/** Overlay riutilizzabile per l'embedded checkout Stripe. */
export default function CheckoutModal({
  clientSecret,
  onClose,
}: {
  clientSecret: string;
  onClose: () => void;
}) {
  return (
    <div
      className="fixed inset-0 z-50 bg-slate-950/90 backdrop-blur-sm overflow-y-auto"
      role="dialog"
      aria-modal="true"
    >
      <div className="min-h-full flex items-start md:items-center justify-center p-3 md:p-6">
        <div className="w-full max-w-2xl bg-white rounded-2xl shadow-2xl overflow-hidden">
          <div className="flex items-center justify-between px-4 py-3 border-b border-slate-200 bg-white">
            <p className="text-sm font-semibold text-slate-900">Completa il pagamento</p>
            <button
              type="button"
              onClick={onClose}
              className="text-slate-500 hover:text-slate-900 transition"
              aria-label="Chiudi"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
          <div className="bg-white">
            <StripeEmbeddedCheckout clientSecret={clientSecret} />
          </div>
        </div>
      </div>
    </div>
  );
}
